<template>
  <div class="browse">
    <div class="browse-inner">
      <div class="firstChild">Browse</div>
      <div class="lineChild"></div>
      <el-tree :data="data" ref="tree" node-key="id" :props="defaultProps" :default-expand-all="defaultExpandAll" accordion @node-click="handleNodeClick"
        :filter-node-method="filterNodeMethod">
      </el-tree>
      <!-- 物种弹出框 -->
      <el-dialog :title="speciesTitle" :visible.sync="speciesVisible" top="30vh" width="40%" style="overflow:hidden;">
        <div class="speciesImg">
          <img :src="speciesImg" />
        </div>
        <div class="speciesStatistics">
          <ul>
            <li v-for="(item, key) in speciesItems" :key="key">{{ item.label }}:
              <span class="linkSpan" @click="jump(item.label)">{{ item.numbers }}</span>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
let url = {
  specie_relation_count: "species/specie_relation_count", // 物种相关，基因、版本、RNA等数据信息接口开发
  specie_all: "species/specie_all", // 物种相关，基因、版本、RNA等数据信息接口开发
};

import { browseData } from './config'

export default {
  data() {
    return {
      speciesTitle: "",
      speciesVisible: false,
      defaultExpandAll: true,
      appendToBody: true,
      speciesImg: "",
      speciesData: [],
      speciesItems: [
        { label: "Genome Info", numbers: "v1.0" },
        { label: "lncRNA", numbers: "0" },
        { label: "Gene", numbers: "0" },
        { label: "Validated lncRNA", numbers: "0" },
        { label: "RNA-Seq", numbers: "0" }
      ],
      data: browseData,
      defaultProps: {
        children: "children",
        label: "label"
      },
      jumpId: '',
      jumpUrl: ''
    };
  },
  created() {
    this.specieAll()
  },
  methods: {
    specieAll() {
      this.http.get(url.specie_all).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            this.speciesData.push(data[i].label)
          }
          this.$refs.tree.filter(this.speciesData)
        }
      }).catch(err => {
        console.log(err);
      });
    },
    specie_relation_count(label) {
      let params = {
        specie_name: label
      }
      this.jumpUrl = ''
      this.http.get(url.specie_relation_count, params).then(res => {
        if (res.data.code == 200) {
          this.speciesItems = [
            { label: "Genome Info", numbers: res.data.data[0].assembly },
            { label: "lncRNA", numbers: res.data.data[0].lncRNAs },
            { label: "Gene", numbers: res.data.data[0].Genes },
            { label: "Validated lncRNA", numbers: res.data.data[0].Var_lncRNAs },
            { label: "RNA-Seq", numbers: res.data.data[0].Run_IDs }
          ]
          this.jumpUrl = res.data.data[0].link
        }
      }).catch(err => {
        console.log(err);
      });
    },
    handleNodeClick(data) {
      if (data.id) {
        this.jumpId = data.id
        this.speciesTitle = data.label;
        this.speciesVisible = true;
        this.speciesImg = require("@/assets/img/" + data.id + ".jpg");
        this.specie_relation_count(data.id)
      }
    },
    jump(val) {
      //   if (val !== 'Genome Info') {
      //     this.$router.push({
      //       path: "/SpeciesDetail",
      //       query: {
      //         speciesName: this.jumpId,
      //         isSpecie: val
      //       }
      //     });
      //   } else {
      //     window.open(this.jumpUrl, '_blank')
      //   }
      if (val === 'Genome Info') {
        val = 'lncRNA'
      }
      this.$router.push({
        path: "/SpeciesDetail",
        query: {
          speciesName: this.jumpId,
          isSpecie: val
        }
      });
    },
    isInArray(arr, value) {
      for (var i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    filterNodeMethod(value, data, node) {
      if (!value) {
        return true
      }
      return this.isInArray(value, data.label)
    }
  }
};
</script>

<style scoped>
.browse {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.browse /deep/ .el-dialog {
  overflow: hidden !important;
  padding-bottom: 20px;
}
.browse .browse-inner {
  width: 1200px;
  padding: 0px 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.browse .browse-inner .firstChild {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
}
.browse .browse-inner .lineChild {
  width: 100%;
  height: 1px;
  background: rgba(229, 233, 235, 1);
}

.browse .browse-inner .el-tree {
  margin-top: 22px;
  padding-bottom: 22px;
}

.el-tree-node__content:hover {
  background-color: #fff;
  color: rgba(139, 182, 68, 1) !important;
}

.el-dialog__header {
  padding: 20px 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
}

.el-dialog__body {
  overflow: hidden;
  padding: 20px 20px;
}

.el-dialog__body .speciesImg {
  margin: 0;
  padding: 0;
  float: left;
  width: 20%;
  height: 100%;
}
.el-dialog__body .speciesImg img {
  width: 100%;
}

.el-dialog__body .speciesStatistics {
  margin: 0;
  padding: 0;
  float: left;
  width: 80%;
  height: 100%;
}
.el-dialog__body ul {
  list-style: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-dialog__body ul li {
  margin: 0;
  padding: 0;
  float: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 200%;
  width: 50%;
}
.el-dialog__body ul li:first-child {
  width: 100%;
}
.speciesStatistics .linkSpan {
  color: #2291f7;
  cursor: pointer;
  text-decoration: underline;
}
.browse >>> .is-leaf + span {
  font-style: italic !important;
  margin-left: 5px;
}
.browse >>> .el-dialog__title {
  font-style: italic !important;
}
</style>
